import { loaderAction, setOtherSettingsAction } from "../rootReducer";
import { api } from "../../helpers/api";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { GetOtherSettingsThunk } from "./GetOtherSettingsThunk";

export const UpdateOtherSettingsThunk = (args) => async (dispatch, getState) => {
    const { user } = getState();

    dispatch(loaderAction(true));

    try {

        let data = JSON.stringify({
            user_id: user.id,
            hash: user.hash,
            field: args.field,
            value: args.value
        });

        const response = await api({ data, link: 'update_other_set' });

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Получаем обновлённые данные
            dispatch(GetOtherSettingsThunk());

            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
    }
    finally {
        dispatch(loaderAction(false));
    }
};